import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import Papa from "papaparse";
import { cdiscManagementService } from "../../../../APIServices/CDISC/cdiscManagementService";

const ImportCMapData = ({
  Show,
  Hide,
  Title,
  studyId,
  downloadCMapTemplate,
  getStudyCDISCCMap,
}) => {
  const [file, setFile] = useState(null);
  const [jsonData, setJsonData] = useState([]);
  const [loader, setLoader] = useState(false);

  const handleCsvUpload = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!selectedFile.name.endsWith(".csv")) {
      Swal.fire("Invalid File", "Please upload only CSV file", "error");
      return;
    }
    setFile(selectedFile);
    Papa.parse(selectedFile, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        setJsonData(result.data);
      },
      error: (err) => {
        Swal.fire("Error", "CSV parsing failed", "error");
      },
    });
  };

  const importStudyCMapCSVFile = async () => {
    if (!jsonData.length) {
      Swal.fire("Error", "CSV file is empty", "error");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to import CMap CSV file?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, import it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
          setLoader(true);
          const payload = {
            jsonData,
            studyId
          };
          const response =
            await cdiscManagementService.importStudyCMapCSVFile(payload);
          if (response?.statusCode === 200) {
            getStudyCDISCCMap();
            setFile(null);
            setJsonData([]);
            Hide();
          }
          setLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <button
          onClick={downloadCMapTemplate}
          className="updateProfile mb-2"
        >
          Download Template
        </button>

        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Upload CSV File</Form.Label>
          <Form.Control
            type="file"
            accept=".csv"
            onChange={handleCsvUpload}
          />
          <Form.Text className="text-muted" style={{ fontSize: 11 }}>
            Note: Upload only template format
          </Form.Text>
        </Form.Group>
      </Offcanvas.Body>

      <div className="border-top text-end p-2">
        <button
          disabled={!file || loader}
          onClick={importStudyCMapCSVFile}
          className="updateProfile"
        >
          {loader ? (
            <span className="d-flex align-items-center gap-2">
              <Spinner size="sm" /> Importing...
            </span>
          ) : (
            "Import"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default ImportCMapData;